const MATMID_TIER_DISPLAY_NAMES = {
    TP: 'Top Platinum',
    PL: 'Platinum',
    GL: 'Gold',
    SL: 'Silver',
    TL: 'Matmid (TL)',
};

/**
 * Returns a human-readable Matmid tier display name for a given tier code.
 *
 * @param {string | null | undefined} tierCode - The raw tier code received from ELAL (e.g. "TP", "GL").
 * @returns {string | null} The human-readable tier name, or the original code if unknown, or null if no code.
 */
export function getMatmidTierDisplayName(tierCode) {
    if (!tierCode) {
        return null;
    }

    const normalizedCode = String(tierCode).trim().toUpperCase();

    return MATMID_TIER_DISPLAY_NAMES[normalizedCode] || normalizedCode;
}

export { MATMID_TIER_DISPLAY_NAMES };

